import React from 'react';
import { NavLink } from 'react-router-dom';
import './NavLinks.css';



const NavLinks = () => {

  return (
    <ul className='nav-links'>
      <li>
        <NavLink to='/naturalization'>Naturalization</NavLink>
      </li>
      <li>
        <NavLink to='/amnesty'>Amnesty</NavLink>
      </li>
      <li>
        <NavLink to='/requirements'>Requirements</NavLink>
      </li>
      <li>
        <NavLink to='/information'>Information</NavLink>
      </li>
    </ul>
  )
}

export default NavLinks
